import React, { Fragment, useContext } from "react";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
  Divider,
  Chip,
  Stack,
  Button,
  Container,
  ButtonGroup,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { calcularLomo } from "../jobViewer/JobDetail";
import arrayNormalizer from "../utils/generalData/arrayNormalizer";
import { getPrivateElementByID } from "../customHooks/FetchDataHook";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import Spinner from "../General/Spinner";
import DialogModal from "./DialogModal";
import UploadFilesButton from "../utils/ReusableComponents/UploadFilesButton";
import { handleUploadSuccess } from "../utils/ReusableComponents/UploadFilesButton";
import AuthContext from "../context/AuthContext";

const DeletePartMessage = "Estas seguro de eliminar esta parte?";

const PartCard = (props) => {
  const [index, setIndex] = React.useState(props.index);
  const [useFinishers, setFinishers] = React.useState([]);
  const [useLoading, setLoading] = React.useState(false);
  const [useError, setError] = React.useState(false);
  const [usePartFiles, setPartFiles ] = [];

  const getFinishers = async (ids = []) => {
    try {
      setLoading(true);

      const results = await Promise.all(
        ids.map((id) => getPrivateElementByID("finishers", id)),
      );

      setFinishers(results);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const context = useContext(AuthContext);
  const uploadUrl = context?.useSettings?.extensions?.pdfValidatorUrl;
  

  const StyledCard = styled(Paper)(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexFlow: "column",
    alignContent: "space-between",
    maxWidth: "600px",
  }));

  React.useEffect(() => {
    if (Array.isArray(props.part?.Finishing)) {
      getFinishers(props.part.Finishing);
    } else {
      setFinishers([]);
    }
  }, [props.part?.Finishing]);

  const alert = (
    <ErrorMessage message={useError.message} action={() => setError(false)} />
  );
  const loading = <Spinner color="info" />;

  if (useLoading) return <Spinner />;
  if (useError) return <ErrorMessage message={useError} />;

  return (
    <StyledCard variant="elevation" square={true} elevation={10}>
      <CardHeader
        title={props.part.Name}
        subheader={`${props.part?.jobParts[0]?.Type}` || ""}
      ></CardHeader>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="body2" sx={{ marginBottom: "10px" }}>
          Paginas: {props.part.Pages} {props.part.RunList ? `(${props.part.RunList})` : ""}
          <br />
          Formato: {props.part.Ancho} x {props.part.Alto}
          <br />
          Impresion: {props.part.ColoresFrente}/{props.part.ColoresDorso}
          <br />
          Material: {props?.part?.partStock?.Nombre_Material}
          {props.part.Pages > 10 ? (
            <>
              {` (Lomo: ${calcularLomo(
                props.part.Pages,
                props.part.partStock.Espesor_Resma,
              )} mm.)`}
            </>
          ) : (
            ""
          )}
        </Typography>
        <UploadFilesButton
          uploadUrl={props.uploadSubDir}
          setPartFiles
          onUploadSuccess={handleUploadSuccess}
          expectedPageCount={props.part.Pages}
          expectedSize={`${props.part.Ancho}x${props.part.Alto}`}
        />
        {Array.isArray(useFinishers) && useFinishers.length > 0 && (
          <Fragment>
            <Divider />
            <List dense disablePadding>
              {useFinishers.map((f) => {
                return (
                  <ListItem disableGutters key={`${f._id}${props.part._id}`}>
                    <ListItemText
                      primary={`Proceso: ${f.Proceso}`}
                      secondary={`Modelo ${f.Modelo}`}
                    />
                  </ListItem>
                );
              })}
            </List>
          </Fragment>
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-start" }}>
        <ButtonGroup size="small" variant="standard">
          <Button
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              props.editPart(index);
              props.setActiveStep(1);
            }}
          >
            Editar
          </Button>
          {
            /* 
          
            Agregar Boton para copiar partes, antes hay que resolver la 
            propiedad _id para que se modifique, porque nos da error la repeticion de ids*/

            <Button
              color="success"
              onClick={(e) => {
                e.preventDefault();
                const copiedPart = { ...props.part };
                delete copiedPart._id;
                copiedPart.jobParts = copiedPart.jobParts.slice(0, 1);
                //console.log("ID Job Part: " + copiedPart.jobParts[0]._id);
                //copiedPart.jobParts.push(props.part.jobParts[0]._id);
                props.copyPart(copiedPart);
                props.setActiveStep(2);
              }}
            >
              Copiar
            </Button>
          }

          <DialogModal
            title={`Eliminar ${props.part.Name}`}
            color="error"
            variant="standard"
            message={DeletePartMessage}
            closeAction={props.removePart}
            index={props.index}
            btnTxt="Eliminar"
            OkBtnTxt="Si"
            CancelBtnTxt="No"
          />
        </ButtonGroup>
      </CardActions>
    </StyledCard>
  );
};

export default PartCard;
